import React from "react";

interface DealerDetailNotFoundProps {
  handleGoBack: () => void;
}

export function DealerDetailNotFound({ handleGoBack }: DealerDetailNotFoundProps) {
  return (
    <div className="container py-8">
      <div className="flex items-center mb-6">
        <button 
          onClick={handleGoBack}
          className="text-sm text-muted-foreground hover:text-foreground transition-colors"
        >
          ← Torna alla lista
        </button>
        <h1 className="text-2xl font-bold ml-4">Dettagli Compro Oro</h1>
      </div>
      <div className="bg-card rounded-lg p-6 border shadow-sm">
        <h2 className="text-xl font-semibold mb-2">Compro Oro non trovato</h2>
        <p className="text-muted-foreground mb-4">
          Non è stato possibile trovare il compro oro richiesto.
        </p>
        <button 
          onClick={handleGoBack}
          className="px-4 py-2 bg-primary text-primary-foreground rounded-md hover:bg-primary/90 transition-colors"
        >
          Torna alla lista
        </button>
      </div>
    </div>
  );
}
